import { make, set } from 'vuex-pathify';

const state = {
    loginUser: {},
};

const mutations = make.mutations(state);

const actions = {
    ...make.actions(state),
    init: async ({ dispatch }) => {},
};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
